module.exports = __webpack_public_path__ + "img/icon15.2c0a9636.png";